import { ArtificialIntelligence08Icon, UserCheck01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { CustomButton } from 'views/CandidateApp/components/CustomButton/CustomButton';

import { IconComponent } from 'components/Icon/IconComponent';

const DEFAULT_CANDIDATE_PREVIEW_COPY =
  'This system is a secure verification platform designed to simplify the process for organisations and volunteers.';

const CandidateExperiencePreview = ({ brand, showHeader = true, candidateIntroductionText }) => {
  const raw = candidateIntroductionText;
  const isLive = raw !== undefined && raw !== null;
  const trimmed = typeof raw === 'string' ? raw.trim() : '';
  const intro = isLive && trimmed !== '' ? raw : null;
  const brandIntroductionText =
    brand?.candidate_introduction_text || DEFAULT_CANDIDATE_PREVIEW_COPY;

  return (
    <div className="flex flex-col gap-8">
      {showHeader && (
        <div className="flex items-center gap-2">
          <HugeiconsIcon icon={ArtificialIntelligence08Icon} size="18" className="text-neutral-6" />
          <span className="text-neutral-7 text-[16px] font-regular">
            Candidate experience preview
          </span>
        </div>
      )}
      <div className="mx-auto flex w-full flex-col gap-6 rounded-3xl border border-neutral-4 p-8">
        <div className="flex flex-col gap-2">
          <span className="text-text-tertiary text-xl">Welcome to Checkmate!</span>
          <h1 className="text-5xl font-semibold">Candidate Name 👋</h1>
          <p className="text-2xl font-light whitespace-pre-wrap text-text-secondary">
            {intro ?? brandIntroductionText}
          </p>
        </div>

        <div className="overflow-hidden rounded-3xl border border-neutral-4 bg-neutral-2/50">
          <div className="flex max-h-[400px] flex-col gap-4 overflow-y-auto p-6">
            <div className="flex items-center gap-4">
              <span className="text-lg font-semibold uppercase text-neutral-7">To Do</span>
              <span className="inline-flex h-8 w-10 shrink-0 items-center justify-center rounded-3xl bg-primary-4/20 text-xl font-medium leading-none text-primary-4 tabular-nums">
                2
              </span>
            </div>

            <div className="flex min-w-0 items-center gap-4 rounded-2xl">
              <IconComponent icon={UserCheck01Icon} strokeWidth="2" size="medium" />
              <span className="min-w-0 flex-1 break-words text-2xl font-regular leading-snug text-neutral-7 line-clamp-2">
                Reference Check
              </span>
            </div>
          </div>
        </div>

        <div className="flex w-full">
          <CustomButton small brand={brand} onClick={() => {}}>
            Get Started
          </CustomButton>
        </div>
      </div>
    </div>
  );
};

export default CandidateExperiencePreview;
